var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"d":"M25.296 8.901l1.502-.661a.5.5 0 01.702.457c0 .57-.23 1.685-.902 3.392-.15 2.863-1.501 7.113-3.914 10.044-3.7 4.492-9.375 5.692-17.197 2.424-.502-.21-.355-.958.19-.962a12.76 12.76 0 005.615-1.339C9.59 21.83 8.243 20.57 7.61 18.814a.51.51 0 01-.022-.08l-.194-.113c-1.729-1.059-2.872-3.118-2.789-5.412l.353-.19c-.861-1.74-.525-3.934.743-5.016a.5.5 0 01.624-.02c2.852 2.123 4.759 3.07 8.201 3.977.456-5.287 6.558-7.484 10.77-3.059z","fill":"currentColor","fillRule":"nonzero","key":1})]));
}

Twitter.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Twitter;

Twitter.default = Twitter;
